import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ResultsPage from './components/ResultsPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/:submissionId" element={<ResultsPage />} />
          <Route path="/" element={<WelcomePage />} />
        </Routes>
      </div>
    </Router>
  );
}

function WelcomePage() {
  return (
    <div className="container">
      <div className="header">
        <h1>AI Ready Results</h1>
        <p>Visualizador de resultados de formularios de IA</p>
      </div>
      <div className="card">
        <h2>Bienvenido</h2>
        <p>Para ver los resultados de un formulario, agrega el Submission ID a la URL:</p>
        <p><strong>Ejemplo:</strong> /afd5824f-05ab-4511-9195-1effc87d05e1</p>
      </div>
    </div>
  );
}

export default App;
